import { RlsPolicyDTO } from "../../dto/rls/policy.dto";

export class RlsPolicy {
    constructor(
        public table_name: string,
        public policy_name: string,
        public roles: string[] = [],
        public cmd: string,
        public using_expr?: string,
        public with_check_expr?: string
    ) {}

    static convertToDTO(model: RlsPolicy): RlsPolicyDTO {
        return {
            table_name: model.table_name,
            policy_name: model.policy_name,
            roles: model.roles,
            cmd: model.cmd,
            using_expr: model.using_expr,
            with_check_expr: model.with_check_expr,
        };
    }

    static fromDTO(dto: RlsPolicyDTO): RlsPolicy {
        return new RlsPolicy(
            dto.table_name,
            dto.policy_name,
            dto.roles,
            dto.cmd,
            dto.using_expr,
            dto.with_check_expr
        );
    }
} 